<nav tuiNavigationNav>
    <a routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" tuiTitle
        ><tui-icon icon="@tui.arrow-big-left" />Dashboard</a
    >
    <a routerLink="flags" routerLinkActive="active" tuiTitle><tui-icon icon="@tui.flag" />Feature Flags</a>
    @if (isOwner$()) {
        <a routerLink="settings" routerLinkActive="active" tuiTitle
            ><tui-icon icon="@tui.settings" />Project Settings</a
        >
        <a routerLink="members" routerLinkActive="active" tuiTitle><tui-icon icon="@tui.users" />Members</a>
        @if (showHistory) {
            <a routerLink="history" routerLinkActive="active" tuiTitle><tui-icon icon="@tui.history" />History</a>
        }
    } @else if (!projectSettingsLoading$()) {
        <div tuiTitle (click)="exitProjectConfirmation()" class="menu-button">
            <tui-icon icon="door-open" />
            Leave Project
        </div>
    }
    <a routerLink="setup" routerLinkActive="active" tuiTitle><tui-icon icon="@tui.file-cog" />How To Setup</a>

    <div tuiTitle (click)="toggleDarkMode()">
        <tui-icon icon="sun-moon" />
        Dark Mode
        <input class="theme-switch" tuiSwitch type="checkbox" size="m" [showIcons]="false" [ngModel]="isDarkMode" />
    </div>
</nav>

@if (leaveProjectLoading$()) {
    <div class="full-screen-loader">
        <tui-loader size="xxl" />
    </div>
}
